import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ExerciseProvider } from "./context/ExerciseContext";
import ExerciseSelector from "./components/ExerciseSelector";
import AdScreen from "./components/AdScreen";
import TimerScreen from "./components/TimerScreen";
import SummaryScreen from "./components/SummaryScreen";

// nové stránky
import About from "./components/pages/About";
import License from "./components/pages/License";
import Disclaimer from "./components/pages/Disclaimer";
import PrivacyPolicy from "./components/pages/PrivacyPolicy";
import Support from "./components/pages/Support";
import Version from "./components/pages/Version";
import Compatibility from "./components/pages/Compatibility";
import Offer from "./components/pages/Offer";

function App() {
    return (
        <ExerciseProvider>
            <Router>
                <Routes>
                    <Route path="/" element={<ExerciseSelector />} />
                    <Route path="/ad" element={<AdScreen />} />
                    <Route path="/timer" element={<TimerScreen />} />
                    <Route path="/summary" element={<SummaryScreen />} />

                    {/* nové administrativní stránky */}
                    <Route path="/about" element={<About />} />
                    <Route path="/license" element={<License />} />
                    <Route path="/disclaimer" element={<Disclaimer />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="/contact" element={<Support />} />
                    <Route path="/version" element={<Version />} />
                    <Route path="/compatibility" element={<Compatibility />} />
                    <Route path="/offer" element={<Offer />} />
                </Routes>
            </Router>
        </ExerciseProvider>
    );
}

export default App;
